
export { gtmAddToWishlist } from "/vercel/path0/packages/@jog/shared/src/gtm/wishlist.ts"
export { gtmRemoveFromWishlist } from "/vercel/path0/packages/@jog/shared/src/gtm/wishlist.ts"